import React from 'react'
import {detail} from "../../../../Constants/Constants"
function Details() {
    const detailList = detail.map(details => (<li> {details}</li>))
    return (
        <div>
            <h2> My Personal Details</h2>
                <h3>{detailList}</h3>
        </div>
    )
}

export default Details
